export interface IScheduleDefault {
  scheduleDate: string
  scheduleHour: number
  linkCalendar?: string
  total?: string
  totalDiscount?: string
  totalWithoutTax?: string
  bookingID?: string
}
